export default __webpack_public_path__ + "static/media/calendar-settings-modal-bg.8bc5e1d3.png";